import React, { useEffect, useState } from "react";

import css from "./SlipContent.module.scss";

export const SlipContent: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <div className={css.SlipContent}>{children}</div>;
};
